module.exports = __webpack_public_path__ + "xzz.png?876a752f8183a20bb1718e9b7ab0038a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xzz.png
// module id = 625
// module chunks = 0